export default "__VITE_ASSET__CnlvJn6O__"